import * as React from 'react';
import { getCheckpointIdRequestId, ValidationStatus } from '../../../../../api/IdVerification';
import '../../../../../styles/IdVerification.css';
import { useEffect, useState } from 'react';
import { EventData } from '../../../../../api/IdVerification';
import { useFetch } from '../../../../../hooks/useFetch';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';

const ORIGIN = 'https://onboarding.checkpointid.com';

interface CheckpointIdVerificationProps {
    goForward: () => void;
    updateVerificationStatus: (success: boolean) => void;
}

const CheckpointIdVerification = (props: CheckpointIdVerificationProps) => {
    const { data, error, loading } = useFetch(getCheckpointIdRequestId, [], null);
    const [validationStatus, setValidationStatus] = useState<ValidationStatus>();

    const parseData = (event: MessageEvent) => {
        if (event.origin !== ORIGIN) {
            return;
        }
        var eventData: EventData = JSON.parse(event.data);
        if (
            eventData.validationStatus.documentIsValid &&
            eventData.validationStatus.faceIsValid &&
            !eventData.validationStatus.expired
        ) {
            props.updateVerificationStatus(true);
            props.goForward();
        } else {
            props.updateVerificationStatus(false);
            setValidationStatus(eventData.validationStatus);
        }
    };

    useEffect(() => {
        window.addEventListener('message', parseData);
        return function cleanup() {
            window.removeEventListener('message', parseData);
        };
    });

    return (
        <div>
            <LoadingOverlay show={loading} inBootstrapColumn={true} />
            {validationStatus && !validationStatus.documentIsValid && (
                <div className="alert alert-danger">Uploaded document could not be verified.</div>
            )}
            {validationStatus && validationStatus.expired && (
                <div className="alert alert-danger">Uploaded document is expired.</div>
            )}
            {validationStatus && !validationStatus.faceIsValid && (
                <div className="alert alert-danger">Selfie photo could not be verified.</div>
            )}
            <FormValidationDisplay errorMessage={error} />
            <div className="row id-verification-iframe-container">
                {data && data.requestId && (
                    <iframe
                        id="iframe"
                        className="id-verification-iframe"
                        allow="camera"
                        height="950px"
                        frameBorder="0"
                        src={
                            `${ORIGIN}/embedded/` +
                            `${process.env.REACT_APP_CHECKPOINT_ID_DOMAIN_KEY}` +
                            `?requestId=${data.requestId}`
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default CheckpointIdVerification;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/verification/CheckpointIdVerification.tsx